import { Grid, GridItem } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../Header';
import Sidebar from '../Sidebar';

function LoggedInArea() {
  const [sidebarFechada, SetSidebarFechada] = useState<boolean>(false)
  const dadosLocalStorage = localStorage.getItem("dadosUsuario");

  useEffect(() => {

    if (dadosLocalStorage) {
      window.addEventListener('sidebarAtualizada', () => {
        const dadosAtualizados = localStorage.getItem("dadosUsuario");
        if(dadosAtualizados) {
          const dadosLocal = JSON.parse(dadosAtualizados);
          SetSidebarFechada(dadosLocal.sidebarFechada)
        }
    })
    }
  }, []);

  return (
    <Grid
      templateRows="1fr 11fr"
      templateColumns="20% 80%"
      width="100%"
      height="100vh"
      box-sizing="border-box"
      padding-left="264px"
      transition="all 0.3s ease-in-out"
      position="relative"
      margin="0 auto"
      display="block"
      float="unset"
      right="0"
      min-height="100vh"
    >
      <GridItem colSpan={1} rowSpan={2}>
        <Sidebar />
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <Header />
      </GridItem>
      <GridItem 
        bgColor="#fafafa" margin={0} paddingLeft={sidebarFechada ? '100px' : '264px'}
        transition="padding-left 0.3s ease"
      >
        <Outlet />
      </GridItem>
    </Grid>
  );
}

export default LoggedInArea;
